<template>
  <div
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.root"
  >
    <div :style="style.container">
      <div
        v-for="index in indices"
        :key="index"
        :style="style.element"
      >
        <slot
          name="element"
          :index="index"
        />
      </div>
      <div
        v-for="index in divisor - (elementLength % divisor)"
        :key="`${index}_filler`"
        :style="style.filler"
      >
        <slot
          name="filler"
          :index="index"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BaseFlexList',
    inheritAttrs: false,
    props: {
      divisor: {
        type: Number,
        required: false,
        default: 12,
      },
      elementLength: {
        type: Number,
        required: false,
        default: 0,
      },
      styleConfig: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        style: {
          container: {
            alignItems: 'center',
            display: 'flex',
            flexWrap: 'wrap',
          },
          element: {},
          filler: {},
          root: {},
        },
      };
    },
    created: function () {
      Object.assign(
        this.style.container,
        this.styleConfig.container,
      );
      Object.assign(
        this.style.element,
        this.styleConfig.element,
      );
      Object.assign(
        this.style.filler,
        this.styleConfig.filler,
      );
      Object.assign(
        this.style.root,
        this.styleConfig.root,
      );
    },
    computed: {
      indices: function () {
        return [...Array(this.elementLength).keys()];
      },
    },
  };
</script>
